import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SmAppVersionComponent} from './sm-app-version.component';
import {SmPlainTextTooltipDirective} from '../../directives/sm-plain-text-tooltip.directive';

@NgModule({
  imports: [CommonModule, SmPlainTextTooltipDirective],
  declarations: [SmAppVersionComponent],
  exports: [SmAppVersionComponent],
})
export class SmAppVersionModule {}
